'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

require('angular/angular');

require('angular-animate/angular-animate');

require('angular-sanitize/angular-sanitize');

require('ionic-sdk/release/js/angular-ui/angular-ui-router');

require('ionic-sdk/release/js/ionic');

require('ionic-sdk/release/js/ionic-angular');

require('angular-stripe/src/index');

require('opbeat-angular/opbeat-angular.min');

require('ng-cordova');

var _angularFileSaver = require('angular-file-saver');

var _angularFileSaver2 = _interopRequireDefault(_angularFileSaver);

var _app = require('./app.run');

var _app2 = _interopRequireDefault(_app);

var _app3 = require('./app.config');

var _app4 = _interopRequireDefault(_app3);

var _app5 = require('./app.controller');

var _app6 = _interopRequireDefault(_app5);

var _app7 = require('./app.directives');

var _app8 = _interopRequireDefault(_app7);

var _app9 = require('./app.services');

var _app10 = _interopRequireDefault(_app9);

var _campaigns = require('./components/campaigns/campaigns.module');

var _campaigns2 = _interopRequireDefault(_campaigns);

var _cart = require('./components/cart/cart.module');

var _cart2 = _interopRequireDefault(_cart);

var _contacts = require('./components/contacts/contacts.module');

var _contacts2 = _interopRequireDefault(_contacts);

var _email = require('./components/email/email.module');

var _email2 = _interopRequireDefault(_email);

var _investors = require('./components/investors/investors.module');

var _investors2 = _interopRequireDefault(_investors);

var _selections = require('./components/selections/selections.module');

var _selections2 = _interopRequireDefault(_selections);

var _settings = require('./components/settings/settings.module');

var _settings2 = _interopRequireDefault(_settings);

var _tasks = require('./components/tasks/tasks.module');

var _tasks2 = _interopRequireDefault(_tasks);

var _team = require('./components/team/team.module');

var _team2 = _interopRequireDefault(_team);

var _user = require('./components/user/user.module');

var _user2 = _interopRequireDefault(_user);

var _imprint = require('./components/imprint/imprint.module');

var _imprint2 = _interopRequireDefault(_imprint);

var _extras = require('./components/extras/extras.module');

var _extras2 = _interopRequireDefault(_extras);

var _rfps = require('./components/rfps/rfps.module');

var _rfps2 = _interopRequireDefault(_rfps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// App dependencies


// Additional
var appModule = angular.module('advinda', ['cleave.js', 'ionic', 'ngCordova', 'pascalprecht.translate', 'LocalStorageModule', 'restangular', 'angular-stripe', 'chart.js', 'angularFileUpload', 'ion-datetime-picker', 'ionic-toast', 'youtube-embed', _angularFileSaver2.default, 'ngOpbeat', _app8.default.name, _app10.default.name, _campaigns2.default.name, _cart2.default.name, _contacts2.default.name, _email2.default.name, _imprint2.default.name, _investors2.default.name, _selections2.default.name, _settings2.default.name, _tasks2.default.name, _team2.default.name, _user2.default.name, _extras2.default.name, _rfps2.default.name]).controller('AppController', _app6.default).constant('DATE_FORMAT', 'MMM dd, yyyy').run(_app2.default).config(_app4.default).directive('spinnerAdvinda', function () {
    return {
        template: '<svg width="40" height="40"><image xlink:href="assets/spinner/advinda-spinner.svg" src="spinner.png" width="40" height="40"/></svg>'
    };
});

exports.default = appModule;


/** WEBPACK FOOTER **
 ** ./src/app/app.js
 **/